<template>
  <teleport to="body">
    <div
      ref="modalEl"
      class="px-[50px] py-[30px] hs-overlay hs-overlay-open:translate-x-0 translate-x-full fixed top-0 right-0 transition-all duration-300 transform h-full max-w-sm w-full z-[60] bg-white border-l hidden"
      tabindex="-1"
    >
      <div
        class="absolute right-[15px] top-[15px] inline-flex hover:cursor-pointer flex-shrink-0 justify-center items-center h-8 w-8 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white"
        data-hs-overlay="#hs-overlay-example"
      >
        <span class="sr-only">Close</span>
        <InlineSvg
          src="/assets/svg/icons/close-blue.svg"
          class="w-[22.627px] h-[22.627px]"
          @click="handleClose"
        />
      </div>
      <slot></slot>
    </div>
  </teleport>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const modalEl = ref(null);
watch(
  () => props.modelValue,
  (newVal) => {
    setTimeout(() => {
      if (newVal) {
        HSOverlay.open(modalEl.value);
      } else {
        HSOverlay.close(modalEl.value);
      }
    });
  },
  { immediate: true }
);
onMounted(() => {
  nextTick(() => {
    if (modalEl.value) {
      modalEl.value.addEventListener('close.hs.overlay', () => {
        emit('update:modelValue', false);
      });
    }
  });
});

const handleClose = () => {
  HSOverlay.close(modalEl.value);
};
</script>

<style scoped></style>
